import React from "react";
import AddIcon from "@material-ui/icons/Add";
import Chip from "@material-ui/core/Chip";
import { Button, FormLabel, TextField } from "@material-ui/core";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

import Paper from "@material-ui/core/Paper";

class ChipArrayWithInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpened: false,
      input: "",
    };
  }

  resetInputState() {
    this.setState({
      dialogOpened: false,
      input: "",
    });
  }

  render() {
    return (
      <div
        style={{
          padding: "0.3rem 0.4rem 0.3rem 0.4rem",
          border: "1px solid grey",
        }}
        className="chiparray_with_input"
      >
        {this.renderDialogBox()}
        <FormLabel>{this.props.title}</FormLabel>
        {this.renderChips()}
        <Button
          color="primary"
          onClick={() => {
            this.setState({ dialogOpened: true });
          }}
        >
          <AddIcon />
        </Button>
      </div>
    );
  }

  renderChips() {
    return (
      <div>
        {this.props.contents.map((item) => (
          <Chip
            key={item}
            label={item}
            onDelete={() => this.handleChipDelete(item)}
          />
        ))}
      </div>
    );
  }

  updateInput(value) {
    this.setState({ input: value });
  }

  renderDialogBox() {
    return (
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={this.state.dialogOpened}
        className="dialog"
      >
        <DialogTitle id="simple-dialog-title">
          {"Adding a new " + this.props.childrenFieldName}
        </DialogTitle>
        <DialogContent style={{ overflow: "hidden" }}>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}
          >
            <TextField
              label={this.props.childrenFieldName}
              variant="outlined"
              className="textfield"
              component={Paper}
              elevation={3}
              value={this.state.input || ""}
              onChange={(event) => this.updateInput(event.target.value)}
            />
          </div>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={this.resetInputState.bind(this)}
            variant="contained"
            color="default"
          >
            Cancel
          </Button>
          <Button
            onClick={this.renderHandleDialogConfirmed.bind(this)}
            variant="contained"
            color="primary"
            autoFocus
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  renderHandleDialogConfirmed() {
    let newContents = this.props.contents;

    // Leave dialogue box open if "Confirm" button clicked without a valid value.
    if (this.state.input === "") {
      return false;
    }

    if (this.state.input) {
      let newPrimaryContents = this.state.input;
      newContents.push(newPrimaryContents);
    }

    this.resetInputState();
    this.props.onChange(newContents);
  }

  handleChipDelete(item) {
    let newContents = this.props.contents;
    var index = newContents.indexOf(item);
    if (index !== -1) {
      newContents.splice(index, 1);
    }

    this.props.onChange(newContents);
  }
}

export default ChipArrayWithInput;
